import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import Home from './pages/Home';
import About from './pages/About';
import YouthTraining from './pages/YouthTraining';
import HRDevelopment from './pages/HRDevelopment';
import Communication from './pages/Communication';
import Research from './pages/Research';
import ProgramManagement from './pages/ProgramManagement';
import Gallery from './pages/Gallery';
import GetInvolved from './pages/GetInvolved';
import Contact from './pages/Contact';
import './App.css';

const HashScrollHandler = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    const targetId = decodeURIComponent(hash.substring(1));
    const targetElement = document.getElementById(targetId);

    if (!targetElement) return;

    const navbarOffset = 90;
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - navbarOffset;
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <Router>
      <HashScrollHandler />
      <div className="App">
        <CustomCursor />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/youth-training" element={<YouthTraining />} />
          <Route path="/hr-development" element={<HRDevelopment />} />
          <Route path="/communication" element={<Communication />} />
          <Route path="/research" element={<Research />} />
          <Route path="/program-management" element={<ProgramManagement />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
